'use client';
import router from 'next/router';
import { useEffect, useMemo, useState } from 'react';

import { Button } from '@app/components/ui/Button';
import { OtherPurposeType, PurposeType } from '@app/constants/property';
import { cn } from '@app/libs/utils';

import ArrowDownIcon from '../icons/ArrowDownIcon';
import Dropdown from '../ui/Dropdown';

interface SearchSectionProps {
  className?: string;
}

export const SearchSection = ({ className }: SearchSectionProps) => {
  const [keyword, setKeyword] = useState<string>('');
  const [type, setType] = useState<string[]>([]);

  const selectOptions = useMemo(
    () =>
      [...Object.entries(PurposeType), ...Object.entries(OtherPurposeType)].map(([key, value]) => ({
        value: key,
        label: value,
      })),
    []
  );

  const handleSearch = () => {
    const query = new URLSearchParams();
    if (keyword) query.append('keyword', keyword);
    if (type.length) query.append('types', type.join(','));

    router.push(`/properties?${query.toString()}`);
  };

  return (
    <section className={cn('search-section w-full flex justify-center', className)}>
      <div className="2xl:w-[90rem] w-full mx-auto px-5 py-8 bg-gray-100 rounded-lg border border-gray-200 transition-all">
        <div className="flex flex-col gap-6">
          <div className="flex flex-col lg:flex-row items-stretch gap-5">
            {/* Ô nhập nội dung tìm kiếm */}
            <div className="flex-1">
              <input
                type="text"
                value={keyword}
                onChange={e => setKeyword(e.target.value)}
                placeholder="Nhập từ khoá để tìm kiếm..."
                className="block w-full border border-gray-300 rounded-lg bg-white px-5 h-14 text-sm leading-relaxed text-gray-700 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-200 focus:border-blue-400"
              />
            </div>

            <div className="w-full lg:w-72">
              <Dropdown
                options={selectOptions}
                value={type}
                onChange={value => setType(value as string[])}
                multiple
                triggerClassName="w-full h-14 rounded-lg text-gray-700 border border-gray-300 font-bold transition-colors cursor-pointer bg-white px-4 flex"
              >
                <>
                  <Button className="border-none bg-transparent overflow-hidden">
                    <span className="text-sm font-medium grow text-left font-normal text-nowrap text-ellipsis overflow-hidden line-clamp-1">
                      {selectOptions
                        .filter(option => type.includes(option.value))
                        .map(option => option.label)
                        .join(', ') || 'Tất cả'}
                    </span>
                  </Button>
                  <ArrowDownIcon className="w-4 h-4 group-[.open]:rotate-180 transition-transform text-gray-700" />
                </>
              </Dropdown>
            </div>

            {/* Nút search ~300px */}
            <div className="w-full lg:w-60">
              <Button
                className="w-full h-14 rounded-lg text-white font-medium transition-colors cursor-pointer bg-blue-800 hover:bg-blue-900"
                onClick={handleSearch}
              >
                Tìm kiếm
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
